// extracted by mini-css-extract-plugin
module.exports = {"icon":"global-search_icon__1Gsva","modal":"global-search_modal__3hywg","modalBody":"global-search_modalBody__1JzL-"};